<template>
  <div>
    <!-- 查询条件 -->
    <div class="queryWrapper">
      <el-form label-width="100px">
        <el-form-item>
          付款时间：
          <el-radio
            v-model="queryForm.evaluateTime"
            @change="timeChange"
            v-for="item in options.evaluateTimeOpt"
            :key="item.value"
            :label="item.value"
            >{{ item.label }}</el-radio
          >
          <div class="my_select_time">
            <el-date-picker
              @change="startDateChange"
              prefix-icon="no_icon"
              v-model="postForm.startDate"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px; font-size: 12px"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div
              class="time_to_text"
              :class="{
                to_text_disabled:
                  queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
              }"
            >
              至
            </div>
            <el-date-picker
              @change="endDateChange"
              prefix-icon="no_icon"
              v-model="postForm.endDate"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px; font-size: 12px"
              class="time2"
              :clearable="true"
            ></el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="clearTimeSendTime()"
            ></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
          <el-button
            class="b1"
            style="margin-left: 8px"
            v-zoom="{ from: pageName, name: '查询' }"
            @click="query()"
            ><span style="marginleft: 4px">
              <i
                class="el-icon-search"
                style="
                  display: inline-block;
                  width: 14px;
                  height: 12px;
                  margin-right: 4px;
                "
              ></i
              >查询</span
            ></el-button
          >
          <el-button class="b2" style="margin-left: 8px" @click="queryOne()"
            ><span style="marginleft: 4px">重置</span></el-button
          >
        </el-form-item>
      </el-form>
      <el-button class="exportData" @click="exportData">导出数据</el-button>
    </div>
    <!-- 提示栏 -->
    <div class="background">
      <span class="title"></span>&nbsp;
      <span class="tips">数据图表</span>
    </div>
    <!-- 图表数据 -->
    <div v-loading="loading">
      <div>
        <div class="float">
          &nbsp; <span class="peopleStyle">{{ people }}</span
          >人&nbsp;&nbsp;&nbsp;
          <span>
            <span class="lineDi"></span>
            基准时间：{{ updataTime }}</span
          >
        </div>
        <div id="order-care" :style="{ width: '100%', height: '400px' }"></div>
      </div>
      <!-- 列表表格 -->
      <div class="background">
        <span class="title"></span>&nbsp;
        <span class="tips">数据报表</span>
      </div>
      <div style="margin-top: 20px">
        <el-table
          :data="recordData"
          style="width: 100%; opacity: 1"
          tooltip-effect="light"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <!-- <el-table-column width="30"></el-table-column> -->
          <el-table-column prop="gradeName" label="会员等级"></el-table-column>
          <el-table-column prop="memberCount" label="会员数"></el-table-column>
          <el-table-column
            prop="buyTotalCount"
            label="订单数"
          ></el-table-column>
          <el-table-column label="成交金额（元）" prop="buyTotalMoney">
            <template slot-scope="scope">
              {{scope.row.buyTotalMoney.toFixed(2)}}
            </template>
          </el-table-column>
          <el-table-column label="客单价（元）">
            <template slot-scope="scope">
              {{ scope.row.unitPrice.toFixed(2)}}
            </template>
          </el-table-column>
          <el-table-column label="会员数占比">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.proportion"></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="订单数占比">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.buyTotalRate"></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="成交额占比">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.buyTotalMoneyRate"></el-progress>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 生成报表 -->
    <generate :control = 'control' 
              v-if="control"
              @transData="(val) => (control = val)"
              @transData1 = 'getphone1'
              ></generate>


  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { buyerGradeCount, exportData,exportDataOne } from "@/api/analysis/monthly-report";
import generate from '../../components/generate_report.vue'
export default {
  name: "monthly_report",
  data() {
    return {
      control:false,
      pageName: "数据分析-会员等级",
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      loading: true,
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "",
            label: "全部",
          },
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "30",
            label: "近一个月",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      queryForm: {
        evaluateTime: "30",
      },
      postForm: {
        startDate: "",
        endDate: "",
      },
      mytime: [],
      zxData: {
        timeFlag: [],
        buyerCount: [],
        tradeCount: [],
        payment: [],
        buyerAvgCost: [],
      },
      recordData: [],
      people: 0,
      updataTime: "",
    };
  },
  components: {
    generate
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  mounted: function () {
    this.timeChange(30);
    this.query();
    this.updataTime = this.getNowDate();
    this.$nextTick(() => {
      this.drawOrderCareBar();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
    localStorage.setItem("oneMonth", JSON.stringify(this.postForm))
  },
  methods: {
    startDateChange(time) {
      this.postForm.startDate = time
    },

    endDateChange(time) {
      this.postForm.endDate = time
    },

    // 导出数据
    async exportData() {
      this.control = true
    },
    getphone1(val){
      let paramStr = "";
      this.postForm.yearRange = 0
      this.postForm.exportRemark  = val
      for (var key in this.postForm) {
        let temp = "&" + key + "=" + this.postForm[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);
      exportDataOne(paramStr).then((res)=>{
         if(res.code==1){
          this.control = true
         }else{
          this.$message.error(res.message);
         }
      })
    },
    //当前时间
    getNowDate() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Seconds = date.getSeconds();

      if (Hours >= 0 && Hours <= 9) {
        Hours = "0" + Hours;
      }
      if (Minutes >= 0 && Minutes <= 9) {
        Minutes = "0" + Minutes;
      }
      if (Seconds >= 0 && Seconds <= 9) {
        Seconds = "0" + Seconds;
      }
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        Hours +
        seperator2 +
        Minutes +
        seperator2 +
        Seconds;
      return currentdate;
    },
    //查询
    query() {
      this.loading = true;
      let self = this;
      buyerGradeCount(this.postForm)
        .then((res) => {
          this.loading = false;
          this.people = 0;
          res.data.forEach((a, b) => {
            this.people += a.memberCount;
          });
          this.people = this.people - res.data[res.data.length - 1].memberCount
          this.recordData = res.data;
          self.zxData.timeFlag = [];
          self.zxData.buyerCount = [];
          self.zxData.tradeCount = [];
          res.data.forEach((val, index) => {
            self.zxData.timeFlag.push(val.proportion); //时间段日期
            self.zxData.buyerCount.push(val.gradeName); //会员数
            self.zxData.tradeCount.push(val.memberCount); //订单数
          });
          self.zxData.buyerCount = self.zxData.buyerCount.slice(0, self.zxData.buyerCount.length - 1)
          self.drawOrderCareBar();
        })
        .catch(() => {});
    },
    //重置
    queryOne() {
      this.queryForm.evaluateTime = "";
      this.postForm.startDate = "";
      this.postForm.endDate = "";
      this.query();
    },
    //时间限制
    clearTimeSendTime() {
      this.postForm.startDate = "";
      this.postForm.endDate = "";
    },
    timeChange(type) {
      let self = this;
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      let nowTime = new Date()
      if (type == 7) {
        this.postForm.startDate = this.mytime[0] + " " + nowTime.toLocaleTimeString();
        this.postForm.endDate = this.mytime[1] + " " + nowTime.toLocaleTimeString();
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = this.mytime[0] + " " + nowTime.toLocaleTimeString();
        this.postForm.endDate = this.mytime[1] + " " + nowTime.toLocaleTimeString();
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
    //绘制柱状图
    drawOrderCareBar() {
      let self = this;
      let orderCareBarChartOne = this.$echarts.init(
        document.getElementById("order-care"),
        "light"
      ); //初始化echats实例
      orderCareBarChartOne.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          data: self.zxData.timeFlag,
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        yAxis: {
          type: "category",
          data: self.zxData.buyerCount,
        },
        series: [
          {
            type: "bar",
            barWidth: 20, //柱图宽度
            data: self.zxData.tradeCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#666",
                    fontSize: 14,
                  },
                },
                color: function (params) {
                  var colorList = [
                    "#8185ea",
                    "#9fa3ed",
                    "#b7b9f1",
                    "#c7c9f3",
                    "#dde0f8",
                    "#dae2e9",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
          },
        ],
      });
      window.onresize = function () {
        orderCareBarChartOne.resize();
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.queryWrapper {
  position: relative;
  margin: 5px 0 20px 35px;

  .exportData {
    position: absolute;
    top: 0;
    right: 0;
  }
}

/deep/.el-progress-bar {
  padding-right: 70px;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  margin-right: -76px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

/deep/.el-progress-bar__inner {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #7e86ec;
  text-align: right;
  border-radius: 100px;
  line-height: 1;
  white-space: nowrap;
  -webkit-transition: width 0.6s ease;
  transition: width 0.6s ease;
}

/deep/.queryWrapper .el-form-item__content {
  margin-left: -30px !important;
}
.section-right-content-box {
  min-width: 1046px;
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;
  .background {
    height: 32px;
    background: rgba(250, 250, 250, 1);
    opacity: 1;
    line-height: 32px;
    padding-left: 12px;
    margin-top: 20px;
    .title {
      display: inline-block;
      width: 2px;
      height: 14px;
      background: rgba(254, 77, 69, 1);
      opacity: 1;
      border-radius: 3px;
      vertical-align: middle;
    }
    .tips {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      vertical-align: middle;
    }
  }
  .b1 {
    width: 98px;
    height: 32px;
    color: #fe4d45;
    font-size: 14px;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    font-size: 14px;
    border-radius: 3px;
    color: #666666;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .echarts {
    width: 100%;
    height: 40px;
    background: #fafafa;
    opacity: 1;
    padding-left: 20px;
    line-height: 40px;
  }
  .clos {
    width: 100%;
    height: 310px;
    background: #ffffff;
    border: 1px solid #f3f4f7;
    opacity: 1;
    padding-left: 20px;
  }
  .float {
    position: relative;
    top: 30px;
    .peopleStyle {
      width: 65px;
      height: 25px;
      font-size: 18px;
      font-weight: 500;
      line-height: 25px;
      color: #333333;
      opacity: 1;
    }
    .lineDi {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      vertical-align: middle;
      background-color: red;
      display: inline-block;
    }
  }
}
</style>
